<!--<div id="container" [ngClass]="{'selected': selected}" [style.border]="getBorderStyle()">-->
<div id="container" [style.border]="getBorderStyle()">
    <div class="outer-dot">
      <div class="inner-dot"></div>
    </div>
  </div>